import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useAuth } from '../../auth'
import { SaveProfile } from '../core/_requests'
import { handleApiError } from '../../utils/apiUtils'
import { useTranslation } from 'react-i18next'

const RegisterProducerCenterStep1 = ({ nextStepSucceed, nextStepFailed, nextStepLoadSucceed, nextStepLoadFailed, showStep1 }) => {

    const { t } = useTranslation()
    const { currentUser, auth, updateUserInfo } = useAuth()
    const [errorMessage, setErrorMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [showWarningMessage, setShowWarningMessage] = useState(false);
    const [loading, setLoading] = useState(false)

    const initialValues = {
        nationalCode: '',
        phoneNumber: currentUser?.phoneNumber
    }

    const registrationSchema = Yup.object().shape({
        nationalCode: Yup.string()
            .matches(/^\d+$/, t('USER.NATIONAL_CODE_NUMERIC'))
            .length(10, t('USER.NATIONAL_CODE_LENGTH'))
            .required(t('USER.NATIONAL_CODE_REQUIRED'))
    })

    const formik = useFormik({
        initialValues,
        validationSchema: registrationSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            try {
                setLoading(true)
                const saveProfileResult = await SaveProfile(values.nationalCode)
                if (saveProfileResult.data?.isSuccess == true) {
                    setWarningMessage('')
                    setShowWarningMessage(false);
                    setErrorMessage('')
                    setShowErrorMessage(false);
                    setSubmitting(true)
                    setLoading(false)
                    nextStepSucceed()
                    nextStepLoadSucceed()
                    updateUserInfo(values.nationalCode)
                }
                else if (saveProfileResult.data?.isSuccess == false) {
                    handleApiError(saveProfileResult, setWarningMessage, setShowWarningMessage, setErrorMessage, setShowErrorMessage)
                    setSubmitting(false)
                    setLoading(false)
                    nextStepFailed()
                    nextStepLoadFailed()
                }
                else {
                    if (saveProfileResult?.response?.data == "Access Denied !") {
                        setErrorMessage(t('COMMON.ACCESS_DENIED'));
                        setShowErrorMessage(true);
                    }
                    else {
                        setStatus(`${t('PRODUCER.SAVE_USER_INFO_ERROR')} : \n ${saveProfileResult}`)
                        setErrorMessage(`${t('PRODUCER.SAVE_USER_INFO_ERROR')} : \n ${saveProfileResult}`)
                        setShowErrorMessage(true);
                    }
                    setSubmitting(false)
                    setLoading(false)
                    nextStepFailed()
                    nextStepLoadFailed()
                }
            }
            catch (error) {
                console.error(error)
                setStatus(t('AUTH.VERIFY.UNKNOWN_ERROR'))
                setSubmitting(false)
                setLoading(false)
                nextStepFailed()
                nextStepLoadFailed()
            }
        }
    })

    return (
        <div className={showStep1 === true ? 'current' : undefined} data-kt-stepper-element='content'>
            <form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                noValidate
                id='kt_add_operation_form'
                onSubmit={formik.handleSubmit}>
                {
                    showErrorMessage ?
                        <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                            <span className="svg-icon svg-icon-2hx svg-icon-danger me-3"></span>
                            <div className="d-flex flex-column">
                                <span>{errorMessage}</span>
                            </div>
                        </div> : null
                }
                {
                    showWarningMessage ?
                        <div className="alert alert-warning d-flex align-items-center p-5 mb-10">
                            <span className="svg-icon svg-icon-2hx svg-icon-warning me-3"></span>
                            <div className="d-flex flex-column">
                                <span>{warningMessage}</span>
                            </div>
                        </div> : null
                }
                <div className='mh-400px scroll-y me-n7 pe-7'>
                    <div className="mb-10">
                        <label className="form-label">{t('USER.NATIONAL_CODE')}</label>
                        <input
                            type="text"
                            autoComplete='off'
                            placeholder={t('USER.NATIONAL_CODE')}
                            {...formik.getFieldProps('nationalCode')}
                            className={clsx(
                                'form-control bg-transparent ltr-direction',
                                {
                                    'is-invalid': formik.touched.nationalCode && formik.errors.nationalCode,
                                },
                                {
                                    'is-valid': formik.touched.nationalCode && !formik.errors.nationalCode,
                                }
                            )}
                        />
                        {formik.touched.nationalCode && formik.errors.nationalCode && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{formik.errors.nationalCode}</div>
                            </div>
                        )}
                    </div>
                    <div className="mb-10">
                        <label className="form-label">{t('AUTH.PHONE_NUMBER')}</label>
                        <input
                            type="text"
                            autoComplete='off'
                            placeholder={t('AUTH.PHONE_NUMBER')}
                            readOnly
                            {...formik.getFieldProps('phoneNumber')}
                            className={clsx(
                                'form-control bg-transparent ltr-direction',
                                {
                                    'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber,
                                },
                                {
                                    'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber,
                                }
                            )}
                        // value={currentUser?.phoneNumber}
                        />
                    </div>
                </div>
                <button
                    type='submit'
                    className='btn btn-lg btn-main w-100 mb-5'
                >
                    {!loading && <span className='indicator-label'>{t('PRODUCER.SUBMIT_AND_NEXT')}</span>}
                    {loading && (
                        <span className='indicator-progress display-block'>
                            {t('AUTH.PLEASE_WAIT')}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            </form>
        </div>
    )
}

export { RegisterProducerCenterStep1 }
